export const YG_DEV_MISSING_SENSORS = [
  'F2:A3:65:5F:EC:80', // Left thigh
  'C6:27:4B:1F:BA:AE', // Left foot
  'FB:8F:72:1D:63:9B', // Right thigh
  'FE:82:64:29:48:E9', // Right foot

  /// MARK: HUB
  // 'EB:AA:0A:09:42:E0',
  // 'D4:38:FA:25:D1:BE',
  // 'ED:2D:1E:B8:5C:5A',
  // 'E3:F5:EB:7E:98:7A',
  // 'FC:4C:B2:A9:E2:57',
  // 'F4:F4:49:15:3E:37',
  // 'E0:5E:27:62:F6:2C',
  // 'DE:96:25:F8:B6:4F',

  // /// LITTLE ENDIAN FORMAT
  // '5A:5C:B8:1E:2D:ED',
  // '7A:98:7E:EB:F5:E3',
  // '57:E2:A9:B2:4C:FC',
  // '37:3E:15:49:F4:F4',
  // '2C:F6:62:27:5E:E0',
  // '4F:B6:F8:25:96:DE',
];
